import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { getProductSearchResultForExchange } from "../../../actions/productDetails";
import { createInvoiceItem, updateInvoiceItem } from "../../../actions/invoiceItem";
import { updateVariation } from "../../../actions/variableProductAction";
import { updateInvoice } from "../../../actions/invoiceItem";
import { DeleteOutlined } from "@ant-design/icons";
import { Layout, Divider, AutoComplete, Row, Col, Form, InputNumber, Button } from "antd";

const { Content } = Layout;

const Dashboard = ({
  details,
  setrefresh,
  getProductSearchResultForExchange,
  wordrobeitems,
  createInvoiceItem,
  updateInvoiceItem,
  updateVariation,
  updateInvoice,
}) => {
  const [cart, setCart] = useState(false);
  const cartItems = useRef([]);
  const [searchresult, setsearchresult] = useState([]);
  const [exchangeProducts, setExchangeProducts] = useState([]);
  const BarcodeInput = useRef(null);
  const location = useRef(details.Location[0].id);
  const [form] = Form.useForm();

  const onKeyUp = (event) => {
    if (event.target.value === "") {
      setsearchresult([]);
    } else {
      if (event.keyCode === 13) {
        getProductSearchResultForExchange(
          event.target.value,
          location.current === 6 ? "" : location.current,
          1,
          100
        ).then((result) => {
          setsearchresult(result.results);
        });
      }
    }
  };

  const addToExchangeProducts = (item) => {
    const existingProduct = exchangeProducts.find(product => product.id === item.id);
    if (existingProduct) {
      if (existingProduct.quantity < item.quantity) {
        existingProduct.selectedQuantity += 1;
        setExchangeProducts([...exchangeProducts]);
      } else {
        alert("Cannot add more than available stock");
      }
    } else {
      setExchangeProducts([...exchangeProducts, { ...item, selectedQuantity: 1 }]);
    }
    form.resetFields();
    setCart(true);
    BarcodeInput.current.focus();
  };

  const removeFromExchangeProducts = (item) => {
    const updatedProducts = exchangeProducts.map(product =>
      product.id === item.id && product.selectedQuantity > 1
        ? { ...product, selectedQuantity: product.selectedQuantity - 1 }
        : product
    ).filter(product => product.selectedQuantity > 0);
    setExchangeProducts(updatedProducts);
  };

  const updateInvoiceItems = () => {
    exchangeProducts.forEach(item => {
      const wordrobeItem = wordrobeitems.find(wordrobeitem => wordrobeitem.product.id === item.id);
      const selectedQuantity = item.selectedQuantity;

      if (wordrobeItem) {
        const newAmount = wordrobeItem.quantity + selectedQuantity;
        if (selectedQuantity <= item.quantity) {
          let formData = new FormData();
          formData.append("quantity", newAmount);
          formData.append("data", "");
          updateInvoiceItem(wordrobeItem.id, formData);
          formData = new FormData();
          formData.append("quantity", item.quantity - selectedQuantity);
          formData.append("data", "");
          updateVariation(item.id, formData).then(() => {
            setsearchresult([]);
            setrefresh(true);
          });
        } else {
          alert("Out of stock");
        }
      } else {
        let formData = new FormData();
        formData.append("product", item.id);
        formData.append("quantity", selectedQuantity);
        formData.append("price", item.selling_price);
        formData.append("invoice", details.id);
        formData.append("data", "");
        createInvoiceItem(formData);
        formData = new FormData();
        formData.append("quantity", item.quantity - selectedQuantity);
        formData.append("data", "");
        updateVariation(item.id, formData).then(() => {
          setsearchresult([]);
          setrefresh(true);
        });
      }
    });
    setExchangeProducts([]);
  };

  useEffect(() => {
    setCart(false);
  }, [cart]);

  const { REACT_APP_API_URL } = process.env;

  return (
    <>
      <Col span={24}>
        <Row>
          <Col span={12}><h3>Exchange Products</h3></Col>
          <Col span={12}>
            <Button 
              style={{ backgroundColor: "whitesmoke", border: "1px solid green", color: "green" }} 
              onClick={updateInvoiceItems}>
              Update
            </Button>
          </Col>
        </Row>
        <Divider />
        <Form form={form}>
          <Form.Item name="remarks" label="" style={{ marginBottom: "0px" }}>
            <AutoComplete
              ref={BarcodeInput}
              placeholder="input search text"
              onKeyUp={onKeyUp}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Form>

        <div>
          {exchangeProducts.map((item, index) => (
            <Row key={index} style={{ border: "1px solid gray", padding: "5px", borderRadius: "5px", backgroundColor: "whitesmoke", marginBottom: "5px" }}>
              <Col span={1} style={{ margin: "auto" }}>
                {index + 1}.
              </Col>
              <Col span={6} style={{ margin: "auto" }}>
                {item.Deatils[0].title}
                <br />
                {item.Attribute_details}
              </Col>
              <Col span={7} style={{ textAlign: "center", margin: "auto" }}>
                <InputNumber
                  min={1}
                  value={item.selectedQuantity}
                  max={item.quantity}
                  onChange={(value) => {
                    const updatedProducts = exchangeProducts.map(product =>
                      product.id === item.id ? { ...product, selectedQuantity: value } : product
                    );
                    setExchangeProducts(updatedProducts);
                  }}
                />
              </Col>
              <Col span={4} style={{ margin: "auto" }}>{item.selling_price}</Col>
              <Col span={5} style={{ margin: "auto" }}>{item.Warehouse_name}</Col>
              <Col span={1} style={{ textAlign: "center", margin: "auto" }}>
                <DeleteOutlined onClick={() => removeFromExchangeProducts(item)} style={{ color: "Red", float: "right", marginTop: "4px" }} />
              </Col>
            </Row>
          ))}
        </div>

        <Divider />
        <div style={{ position: "absolute", width: "100%", zIndex: "5" }}>
          {searchresult.map((item, index) => {
            if (index < 20 && item.is_active) {
              return (
                <Row
                  key={index}
                  style={{
                    width: "100%",
                    border: "1px solid lightgray",
                    padding: "5px",
                    borderRadius: "5px",
                    backgroundColor: "whitesmoke",
                    textAlign: "center", margin: "auto",
                    cursor: "pointer",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e6f7ff"}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "whitesmoke"}
                  onClick={() => addToExchangeProducts(item)}
                >
                  <Col span={8} style={{ margin: "auto" }}>
                    {item.Deatils[0].title}
                    <br />
                    {item.Attribute_details}
                  </Col>
                  <Col span={4} style={{ margin: "auto" }}>{item.quantity}</Col>
                  <Col span={4} style={{ margin: "auto" }}>{item.selling_price}</Col>
                  <Col span={4} style={{ margin: "auto" }}>{item.Warehouse_name}</Col>
                </Row>
              );
            }
          })}
        </div>
      </Col>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    List: state.ProductDetails.productdetails,
  };
};

export default connect(mapStateToProps, {
  getProductSearchResultForExchange,
  createInvoiceItem,
  updateVariation,
  updateInvoiceItem,
  updateInvoice,
})(Dashboard);

